const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  store ({ state, commit, rootState }, params) {
    return rootState.axios.get('/knapsack/v1frontend/knapsack-goods/store', { params })
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/knapsack/v1frontend/knapsack-goods/view', { params })
  },
  coinPurchase ({ state, commit, rootState }, params) {
    return rootState.axios.post('/knapsack/v1frontend/knapsack-goods/coin-purchase', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
